import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { getLocationState } from '../../utils/listPageState'
import {
    applyAppPopupDraft,
    NEW_APP_POPUP_DRAFT_KEY,
    readAppPopupDraft,
} from './appPopupDraftUtils'
import AppPopupFormPage from './AppPopupFormPage'
import useAppPopupFormFlow from './useAppPopupFormFlow'

export default function NewAppPopup() {
    const location = useLocation()
    const history = useHistory()
    const locationState = getLocationState(location)
    const listCurPage = locationState.curPage || 1
    const listSearch = location.search || ''
    const listSearchSelect = locationState.searchSelect
    const draftKey = NEW_APP_POPUP_DRAFT_KEY
    const storedDraftRef = useRef(readAppPopupDraft(draftKey))
    const [saving, setSaving] = useState(false)
    const [draftReady, setDraftReady] = useState(false)
    const [params, setParams] = useState({
        deviceType: 'all',
        type: 1,
        status: 1,
        landingUrl: '',
        meetId: null,
    })
    const [image, setImage] = useState('')
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [severitySnackbar, setSeveritySnackbar] = useState('info')
    const [messageSnackbar, setMessageSnackbar] = useState('')

    const listState = {
        search: listSearch,
        curPage: listCurPage,
        searchSelect: listSearchSelect,
    }

    const showError = useCallback((message) => {
        setOpenSnackbar(true)
        setSeveritySnackbar('error')
        setMessageSnackbar(message)
    }, [])

    const {
        setInitialDraftSnapshot,
        restorePickerState,
        leaveGuardEnabled,
        productPicker,
        handlers,
    } = useAppPopupFormFlow({
        draftKey,
        draftEnabled: draftReady,
        params,
        setParams,
        setImage,
        saving,
        setSaving,
        history,
        listState,
        saveConfig: {
            endpoint: '/api/v1/admin/appPopup/create',
            failureMessage: 'App 랜덤 팝업을 등록하지 못했습니다.',
        },
        pickerConfig: {
            initialPage: storedDraftRef.current?.pickerPage,
            initialSearchText: storedDraftRef.current?.pickerSearchText,
            initialSearchSelect: locationState.searchSelect,
        },
        showError,
    })

    useEffect(() => {
        const baseParams = {
            deviceType: 'all',
            type: 1,
            status: 1,
            landingUrl: '',
            meetId: null,
        }
        const restoredDraft = applyAppPopupDraft({
            baseParams,
            basePickerPage: 1,
            basePickerSearchText: '',
            draft: storedDraftRef.current,
        })

        setInitialDraftSnapshot({
            params: baseParams,
            pickerPage: 1,
            pickerSearchText: '',
        })

        setParams(restoredDraft.params)
        restorePickerState({
            page: restoredDraft.pickerPage,
            searchText: restoredDraft.pickerSearchText,
        })
        setDraftReady(true)
    }, [restorePickerState, setInitialDraftSnapshot])

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    const snackbar = {
        open: openSnackbar,
        severity: severitySnackbar,
        message: messageSnackbar,
        onClose: handleClose,
    }

    return (
        <AppPopupFormPage
            title="App 랜덤 팝업 등록"
            params={params}
            image={image}
            saving={saving}
            leaveGuardEnabled={leaveGuardEnabled}
            listState={listState}
            snackbar={snackbar}
            productPicker={productPicker}
            onSubmit={handlers.onSubmit}
            onImageChange={handlers.onImageChange}
            onFieldChange={handlers.onFieldChange}
            onBackClick={handlers.onBackClick}
        />
    )
}
